import { useEffect, useRef } from "react";

const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const VERSION_URL = `${publicUrl}/version.txt`.replace(/\/+/g, "/") || "/version.txt";

async function fetchBuildStamp() {
  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const text = (await res.text()).trim();
    return text || null;
  } catch {
    return null;
  }
}

/**
 * Sunucudaki build sürümü değişince tam sayfa yeniler (yeni JS/CSS yüklenir).
 * Müşteriye "yenile" demek yerine birkaç dakika içinde kendiliğinden güncellenir.
 */
export function useDeployVersionPing(options = {}) {
  const intervalMs = options.intervalMs ?? 600000;
  const bootStampRef = useRef(null);
  const readyRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    const earlyTimeoutIds = [];

    const check = async () => {
      if (!readyRef.current || !bootStampRef.current) return;
      const v = await fetchBuildStamp();
      if (cancelled || !v) return;
      if (v !== bootStampRef.current) {
        window.location.reload();
      }
    };

    (async () => {
      const v = await fetchBuildStamp();
      if (cancelled || !v) return;
      bootStampRef.current = v;
      readyRef.current = true;
      // Aynı sekmede 10 dk beklemeden: deploy sonrası kısa sürede yakala
      [15000, 45000, 120000].forEach((ms) => {
        earlyTimeoutIds.push(
          setTimeout(() => {
            if (!cancelled) check();
          }, ms)
        );
      });
    })();

    const id = setInterval(check, intervalMs);
    const onFocus = () => check();
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      cancelled = true;
      earlyTimeoutIds.forEach((tid) => clearTimeout(tid));
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [intervalMs]);
}
